// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"472":"settings","594":"about"}[chunkId] || chunkId) + "." + {"125":"6395af41","179":"a23989ab","427":"f50a7b44","472":"94ecbe89","594":"dae87027"}[chunkId] + ".js";
};